export default __webpack_public_path__ + "static/media/Thumb_Shoes_02.d89122e0.png";